import {
  styled, FormControl as MuiFormControl,
  FormControlProps as MuiFormControlProps,
  formHelperTextClasses,
  outlinedInputClasses,
  formControlClasses,
} from '@mui/material';
import {
  Spacing2, Spacing3, Spacing6, Spacing7,
} from '../spacing';
import { inputBaseClasses } from '../inputBase/types';

export interface FormControlOwnProps {
  /**
   * Should the label be on top (default) or left (only for size=small)
   * @default undefined
   */
  labelPosition?: undefined | 'left';
}

export type FormControlProps = FormControlOwnProps & MuiFormControlProps;

export const FormControl = styled(MuiFormControl)<FormControlProps>(({ size, labelPosition }) => ({
  ...(size === 'small' && labelPosition === 'left'
    ? {
      display: 'inline-grid',
      gridTemplateColumns: 'minmax(min-content, max-content) minmax(50%, 1fr)',
      gridTemplateRows: `${Spacing7} auto`,
      rowGap: Spacing2,
      columnGap: Spacing3,
      label: {
        alignSelf: 'center',
        justifySelf: 'end',
        marginBottom: 0,
      },
      [`.${formHelperTextClasses.root}`]: {
        gridColumn: 2,
        marginTop: 0,
      },
      [`.${inputBaseClasses.inputSizeSmall}.${outlinedInputClasses.input}`]: {
        height: Spacing6,
        padding: `${Spacing2} ${Spacing3}`,
      },
      [`&.${formControlClasses.fullWidth}`]: {
        gridTemplateColumns: 'fit-content(50%) minmax(50%, 100%)',
      },
    }
    : {}),
}));
